import React, { useState, useEffect } from 'react';
import api from '../api';
import { format } from 'date-fns';

export const WebhookEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [provider, setProvider] = useState('');

  useEffect(() => { fetchEvents(); }, [provider]);

  async function fetchEvents() {
    setLoading(true);
    try {
      const q = provider ? `?provider=${provider}&limit=100` : '?limit=100';
      const { data } = await api.get(`/admin/webhook-events${q}`);
      setEvents(data.data.events);
    } catch (err) {
      setEvents([]);
    } finally { setLoading(false); }
  }

  const providerColor = { stripe: '#635bff', sumsub: '#00cc99', plaid: '#00d4ff' };

  return (
    <div>
      <div className="card-header" style={{ padding: '0 0 24px 0', border: 'none' }}>
        <h1 className="page-title" style={{ margin: 0 }}>Webhook Events</h1>
        <select className="dropdown" value={provider} onChange={e => setProvider(e.target.value)}>
          <option value="">All providers</option>
          <option value="stripe">Stripe</option>
          <option value="sumsub">Sumsub</option>
          <option value="plaid">Plaid</option>
        </select>
      </div>

      <p style={{ color: 'var(--text-secondary)', marginBottom: 16, fontSize: 13 }}>
        Every webhook we've processed. Replayed events are deduped and never processed twice.
      </p>

      <div className="glass">
        <div className="table-container" style={{ border: 'none', borderRadius: '16px' }}>
          {loading ? <div className="loader-container"><div className="spinner"></div></div> : (
            <table>
              <thead>
                <tr>
                  <th>Event ID</th>
                  <th>Provider</th>
                  <th>Type</th>
                  <th>Processed</th>
                </tr>
              </thead>
              <tbody>
                {events.map(e => (
                  <tr key={e.id}>
                    <td style={{ fontFamily: 'monospace', fontSize: 12, color: 'var(--accent)' }}>{e.id}</td>
                    <td>
                      <span className="badge" style={{ background: (providerColor[e.provider] || '#999') + '22', color: providerColor[e.provider] || '#999' }}>
                        {e.provider}
                      </span>
                    </td>
                    <td style={{ fontFamily: 'monospace', fontSize: 13 }}>{e.eventType}</td>
                    <td style={{ color: 'var(--text-secondary)', fontSize: 12 }}>
                      {format(new Date(e.processedAt), 'MMM dd, yyyy HH:mm:ss')}
                    </td>
                  </tr>
                ))}
                {events.length === 0 && (
                  <tr><td colSpan="4" style={{ textAlign: 'center', padding: 32, color: 'var(--text-secondary)' }}>No events yet.</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};
